// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3rHi_","requiredAsterisk":"Info_requiredAsterisk__OYlFt"};